// extracted by mini-css-extract-plugin
export default {"input":"AddressInput_input__5+ryb"};